<script setup lang="ts">
import NationalOrgGridSkeleton from '~/components/orga/NationalOrgGridSkeleton.vue'
import {
  DIRECTION_PAGE_INIT_COL_COUNT,
  DIRECTION_PAGE_INIT_ITEMS_PER_COL,
} from '~/composables/direction/page/useDirectionPageLoad'
</script>

<template>
  <NationalOrgGridSkeleton
    :show-comex="false"
    :column-count="DIRECTION_PAGE_INIT_COL_COUNT + 1"
    :items-per-column="DIRECTION_PAGE_INIT_ITEMS_PER_COL"
  />
</template>
